<template>
  <div ref="holder" />
</template>

<style lang="scss" scoped></style>

<script>
import $ from 'jquery'
import _ from 'lodash'
import SVG from 'svg.js'

// *****************************************************************************

export default {
  name: 'TextFitter',
  components: {},
  props: ['value', 'font'],
  data() {
    return {
      canvas: undefined,
      text: undefined,
    }
  },
  computed: {},
  watch: {
    value(nv, ov) {
      this.recompute()
      this.fit()
    },
    font(nv, ov) {
      this.recompute()
      this.fit()
    },
  },
  beforeMount() {
    this.fit = this.fit.bind(this)
  },
  mounted() {
    let el = this.$refs.holder
    this.holder = $(el)
    let canvas = SVG(el).viewbox(0, 0, 0, 0)
    this.canvas = canvas
    this.canvas.attr('preserveAspectRatio', 'none')

    $(window).on('resize', this.fit)
    this.recompute()
    this.fit()
  },
  beforeDestroy() {
    $(window).off('resize', this.fit)
  },
  methods: {
    fit() {
      let ew = this.holder.width()
      let eh = this.holder.height()
      let th = this.th
      let tw = this.tw
      this.canvas.size(`${tw}px`, `${th}px`)
      let h = this.th
      let w = tw
      if (ew < tw && ew !== 0) {
        w = (tw * tw) / ew
      }
      w = w < 0 ? 0 : w
      h = h < 0 ? 0 : h
      this.canvas.viewbox(0, 0, w, h)
    },
    recompute() {
      if (!_.isUndefined(this.text)) {
        this.text.remove()
      }
      let text = this.canvas.plain(this.value)
      this.text = text
      text.font(this.font)
      text.attr({ x: 0, y: this.font.size })
      let { w: tw, h: th } = text.bbox()
      this.tw = tw
      this.th = th
      this.canvas.viewbox(0, 0, tw, th)
    },
  },
}
</script>
